import PropTypes from 'prop-types';
import backButtonUrl from './back-button.svg';

export const YOU_BACK_ICON_URL = backButtonUrl;

export const YouBackIcon = ({ size = 24, alt = '' }) => (
  <img
    src={backButtonUrl}
    alt={alt}
    width={size}
    height={size}
    data-testid="you-back-icon"
  />
);

YouBackIcon.propTypes = {
  size: PropTypes.number,
  alt: PropTypes.string,
};

export default YouBackIcon;
